function extractMessageFromErrorString(message: string): string | null {
  const regex = /"message":"(.*?)"/;
  const match = message.match(regex);

  if (match) {
    return match[1];
  }

  const jsonStart = message.indexOf(': {');

  if (jsonStart > 0) {
    return message.substring(0, jsonStart);
  }

  return null;
}

export default extractMessageFromErrorString;
